"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconReinsuranceWineMarketplace = void 0;
var React = __importStar(require("react"));
var IconReinsuranceWineMarketplace = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M19 20.5L19 10.313C19 10.213 18.971 10.115 18.914 10.032L17.191 7.491C17.055 7.228 17 6.996 17 6.765L17 6 16 6 16 6.765C16 6.996 15.945 7.228 15.842 7.435L14.086 10.032C14.029 10.115 14 10.213 14 10.313L14 20.5C14 20.775 14.225 21 14.5 21L18.5 21C18.775 21 19 20.775 19 20.5zM16 5L17 5 17 3 16 3 16 5zM19.742 9.472C19.911 9.721 20 10.012 20 10.313L20 20.5C20 21.327 19.327 22 18.5 22L14.5 22C13.673 22 13 21.327 13 20.5L13 10.313C13 10.012 13.089 9.721 13.258 9.472L14.98 6.931C14.981 6.918 15 6.842 15 6.765L15 2 18 2 18 6.765C18 6.842 18.019 6.918 18.053 6.987L19.742 9.472zM14.75 10.417L16.3 8.35 16.7 8.65 15.25 10.583 15.25 20 14.75 20 14.75 10.417zM10 20.5L10 10.313C10 10.213 9.971 10.115 9.914 10.032L8.191 7.491C8.055 7.228 8 6.996 8 6.765L8 6 7 6 7 6.765C7 6.996 6.945 7.228 6.842 7.435L5.086 10.032C5.029 10.115 5 10.213 5 10.313L5 20.5C5 20.775 5.225 21 5.5 21L9.5 21C9.775 21 10 20.775 10 20.5zM7 5L8 5 8 3 7 3 7 5zM9.053 6.987L10.742 9.472C10.911 9.721 11 10.012 11 10.313L11 20.5C11 21.327 10.327 22 9.5 22L5.5 22C4.673 22 4 21.327 4 20.5L4 10.313C4 10.012 4.089 9.721 4.258 9.472L5.98 6.931C5.981 6.918 6 6.842 6 6.765L6 2 9 2 9 6.765C9 6.842 9.019 6.918 9.053 6.987zM5.75 10.417L7.3 8.35 7.7 8.65 6.25 10.583 6.25 20 5.75 20 5.75 10.417z" }))); };
exports.IconReinsuranceWineMarketplace = IconReinsuranceWineMarketplace;
exports.IconReinsuranceWineMarketplace.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconReinsuranceWineMarketplace;
